import FormKeys from 'forms-utils-lib/constants/formDefinition/FormKeys';
import createFormStyle from 'forms-utils-lib/formStyle/utils/createFormStyle';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
const defaultForm = {
  [FormKeys.GUID]: '',
  [FormKeys.NAME]: '',
  [FormKeys.UPDATED_AT]: '',
  [FormKeys.FORM_FIELD_GROUPS]: [],
  [FormKeys.DELETABLE]: false,
  [FormKeys.CLONEABLE]: false,
  [FormKeys.CREATED_AT]: '',
  [FormKeys.CAPTACHA_ENABLED]: false,
  [FormKeys.META_DATA]: [],
  [FormKeys.EMBED_VERSION]: '',
  [FormKeys.NOTIFY_RECIPIENTS]: '',
  [FormKeys.SUBMIT_TEXT]: '',
  [FormKeys.FORM_TYPE]: FormTypes.HUBSPOT,
  [FormKeys.STYLE]: createFormStyle({}),
  [FormKeys.ALWAYS_CREATE_NEW_COMPANY]: false,
  [FormKeys.CREATE_MARKETABLE_CONTACT]: false,
  [FormKeys.REDIRECT_PAGE]: '',
  [FormKeys.THANK_YOU_MESSAGE]: '',
  [FormKeys.THEME_NAME]: '',
  [FormKeys.FIELD_PREPOPULATION]: false
};
export default defaultForm;